import Vue from 'vue'
import { Mutation } from 'vuex'
import { MediaLibraryState } from '../types'
import { MediaLibraryEssence } from '@/types/mediaLibrary'

const setEssence: Mutation<MediaLibraryState> = (
  state,
  {
    essence,
    essenceId,
  }: {
    essence: MediaLibraryEssence
    essenceId: number
  }
) => {
  const mediaLibrary = new Map(state.value)

  if (
    mediaLibrary.get(essence) &&
    mediaLibrary.get(essence)?.essenceId === essenceId
  ) {
    return
  }

  mediaLibrary.set(
    essence,
    Vue.observable({
      essence,
      essenceId,
      images: [],
      pendingRequests: [],
      loading: false,
      hasMore: false,
    })
  )

  state.value = mediaLibrary
}

export default setEssence
